<template>
  <div>
    <md-table
      v-model="data"
      v-if="!isEmpty(data)"
      :table-header-color="tableHeaderColor"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell
          v-for="(field, index) in fields"
          :md-label="field.name"
          :key="index"
        >
          <span v-if="isEmpty(field.type) || field.type === 'text'">{{
            item[field.code] | callFilter(item, field)
          }}</span>
          <span
            v-else-if="field.type === 'html'"
            v-html="call_filter_method(item[field.code], item, field)"
          ></span>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { isEmpty } from "@/utils";
export default {
  name: "simple-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    },
    data: [],
    fields: null
  },
  methods: {
    isEmpty: isEmpty,
    call_filter_method(data, data_set, field) {
      return this.$options.filters["callFilter"](data, data_set, field);
    }
  },
  filters: {
    callFilter(data, data_set, field) {
      let filter = field.filter;
      if (filter === undefined) {
        return data;
      }
      // 收集指定的其它辅助字段（适用于一列要通过多个字段共同展示的情况）
      let other_datas = [];
      if (!isEmpty(data_set) && !isEmpty(field.others)) {
        for (let code of field.others) {
          other_datas.push(data_set[code]);
        }
      }
      return filter(data, other_datas);
    }
  },
  data() {
    return {
      callFilter: this.callFilter,
      selected: []
    };
  }
};
</script>
